<button class="w-full text-left flex gap-x-3 py-4 border-b border-b-neutral-300 px-4" (click)="clickCard()">
  @if (imageUrl) {
    <div class="w-[70px] h-[70px] rounded-full overflow-hidden bg-gray-300 border border-gray-200">
      <img loading="lazy" [src]="imageUrl" width="70" height="70" alt="" class="object-cover w-full h-full" />
    </div>
  }

  <div class="flex-1 flex flex-col justify-center gap-1 overflow-x-auto">
    <p class="text-neutral-600 text-base font-semibold">
      {{ title }}
    </p>

    @if (tags.length > 0) {
      <div class="flex gap-x-2 tags mb-1 overflow-x-auto">
        @for (tag of tags; track tag) {
          <div class="rounded flex px-2 py-1 bg-neutral-200">
            <img class="w-4 h-4 object-contain" src="assets/category-icons/{{ tag }}.svg" />
          </div>
        }
      </div>
    }

    @if (price && (priceDiscount === null || priceDiscount === undefined)) {
      <p class="text-xs font-semibold" ctrHotelColor>
        {{ price }}
      </p>
    }

    @if (price && priceDiscount !== null && priceDiscount !== undefined) {
      <div class="flex gap-x-2">
        <p class="text-sm font-semibold" ctrHotelColor>
          {{ priceDiscount }}
        </p>

        <p class="text-sm font-semibold line-through text-neutral-600">
          {{ price }}
        </p>
      </div>
    }
  </div>
</button>
